import React from "react";
import { Box, CircularProgress, IconButton, Tooltip } from "@mui/material";

/**
 * ActionCell — renders a row of icon-button actions for a table row.
 *
 * actions: Array of:
 *   { label, icon, onClick, color, disabled, loading, sx }
 *
 * - label:    Tooltip text
 * - icon:     ReactNode (MUI icon)
 * - onClick:  click handler
 * - color:    icon color (default "#065F46")
 * - disabled: boolean
 * - loading:  boolean — shows CircularProgress instead of icon
 * - sx:       additional sx for IconButton
 */
const ActionCell = ({ actions = [] }) => (
  <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 0.5 }}>
    {actions.map((action, i) => (
      <Tooltip key={i} title={action.label} placement="top">
        <span>
          <IconButton
            size="small"
            onClick={action.onClick}
            disabled={action.disabled || action.loading}
            sx={{ color: action.color || "#065F46", ...(action.sx || {}) }}
          >
            {action.loading
              ? <CircularProgress size={16} sx={{ color: action.color || "#065F46" }} />
              : action.icon}
          </IconButton>
        </span>
      </Tooltip>
    ))}
  </Box>
);

export default ActionCell;
